<div class="General">
  <h3 style="font-size: 1.8rem;" class="page-title">Schedule an appointment</h3>
  <!-- <p>Placeholder text:</p> -->

  <p class="form-label">if you know your assigned district office, select below</p>
  <select #t (change)="navigateTo(t.value)" class="form-control form-control-lg">
    <option>Select</option>
    <option value="LACAssessorNorthDistrict">North District</option>
    <option value="LACAssessorEastDistrict">East District</option>
    <option value="LACAssessorWestDistrict">West District</option>
    <option value="LACAssessorSouthDistrict">South District</option>
    <option value="LACAssessorLancasterDistrict">Lancaster Regional</option>
  </select>
  <br>
  <p class="form-label">if you do not know your assigned district office, search by ain or address</p>

  <div class="">
    <app-findProperty [color]="'#3165b1'" [title]="'ContactAssessor.District' | translate" [imgItem]="false"  (ParcelItem)="getAddress($event)"></app-findProperty>
  </div>
</div>
